
import './App.css';
import React from 'react';
import { LinkCard } from './components/LinkCard';
import { useLinkData } from './hooks/useLinkData';
import { LogoHeader } from './components/LogoHeader';

function App() {
  const data = useLinkData();

  if (!data) return <div className="loading">Loading...</div>;

  return (
    <div className="App">
      <LogoHeader logo={data.logo} name={data.name} tagline={data.tagline} />
      <div className="container">
        {data.links.map((link, idx) => (
          <LinkCard key={idx} link={link} />
        ))}
      </div>
    </div>
  );
}

export default App;